

// Libs
import React, { useState } from 'react';
import { Button, Layout, Result } from 'antd';
import NackleMenu from '@nackle/menu';
const { Content } = Layout;
import { setLanguageBundle } from '@nackle/intl-tools';
// Routing
import { Route, routeHistory } from '@nackle/biw-web-router';
import { routes, bundleRoutingMiddleware } from './routing.jsx';

// Bridge
import { Bridge } from '@nackle/bridge';
import auth from './auth.js';
import { applyRequestMiddleware, authRouteMiddleware, authRequestMiddleware, fetch } from '@nackle/studio-tools';

// Components
import { AppHeader, AppFooter, AppError, CMXService } from '@nackle/studio-tools';


import { AuthProvider } from '@nackle/umbrella-studio';


// styles
import './assets/styles/app.less';


/*******************************************************************************
 *  1. App (root level component)
 */

const App = () => {
    const [ loaded, setLoaded ] = useState( false );
    const [ cmxBundleLoaded, setCmxBundleLoaded ] = useState( false );
    const [ user, setUser ] = useState( {} );


    const handleSignIn = async ( user ) => {
        const cmxService = new CMXService( auth.state );
        const { locale } = user.claims;
        const bundle = await cmxService.getBundle( [ 'navigation' ], locale );
        await setLanguageBundle( locale, bundle );

        setLoaded( true );
        setCmxBundleLoaded( true );
        setUser( user );
    };

    return (
        <AppError>
            <Route render={ ( route ) => {
                // set the title
                document.title = route && route.match ? route.match.title : 'Home';
                return (
                    <Bridge
                        auth={ auth }
                        onSignIn={ ( user ) => handleSignIn( user ) }
                    >   
                        <AuthProvider auth={ auth }>
                            {
                                loaded ? (
                                    <Layout className="root-layout">
                                        <AppHeader 
                                            auth={ auth } 
                                            companyId={ user?.claims?.company_id } 
                                            companySelectDisabled={ true }
                                        />
                                        <Layout>
                                            <NackleMenu
                                                auth={ auth }
                                                cmxBundleLoaded={ cmxBundleLoaded }
                                                collapsible={ true }
                                            />
                                            <Layout className="page-layout">
                                                <Content className="app-content">
                                                    {
                                                        route.match ?
                                                            <div className="app-container">
                                                                <div className="main-container">
                                                                    { React.cloneElement( route.component, { companyId: user?.claims?.company_id, user, fetch, isUmbrella: false } ) }
                                                                </div>
                                                            </div>
                                                        : (
                                                            <Result
                                                                status="404"
                                                                title="404"
                                                                subTitle="Sorry, the page you visited does not exist."
                                                                extra={ <Button type='primary' href='/'>Back Home</Button> }
                                                            />
                                                        )
                                                    }
                                                </Content>
                                                <AppFooter />
                                            </Layout>
                                        </Layout>
                                    </Layout>
                                ) : null
                            }
                        </AuthProvider>  
                    </Bridge>
                );
            } } />
        </AppError>
    );
};


/*******************************************************************************
 *  2. Connect Routing
 */
routeHistory.applyRoutes( routes );
routeHistory.applyMiddleware( [ authRouteMiddleware( auth ), bundleRoutingMiddleware ] );

/*******************************************************************************
 *  3. Connect Auth to Fetch
 */
applyRequestMiddleware( authRequestMiddleware( auth ) );


export default App;


